import React from 'react';
import { connect } from 'react-redux';

import sectionActions from 'actions/editor';

import WindowLocation from '../shared/window_location';

const EditorWindowLocation = props => (
  <WindowLocation {...props} stateKey="editor" />
);

const mapStateToProps = ({ editor }) => ({
  state: { id: editor.currentSection.id },
  url: editor.url,
});

const mapDispatchToProps = dispatch => ({
  onPopState(state) {
    if (state && state.editor) {
      dispatch(sectionActions.edit(state.editor.id, false));
    }
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EditorWindowLocation);
